import { postApi } from "@/axios/interceptors";
export default {
  getBizCode() {
    return postApi.post("/code/getBizCode", { code: "910" });
  },
  getBadCode(data: any) {
    return postApi.post("/code/getBadCode", data);
  },
  getBadSubCode(data: any) {
    return postApi.post("/code/getBadSubCode", data);
  },
  setBadCode(data: any) {
    return postApi.post("/code/setBadCode", data);
  },
  setBadSubCode(data: any) {
    return postApi.post("/code/setBadSubCode", data);
  },
  getRepairCode(data: any) {
    return postApi.post("/code/getRepairCode", data);
  },
  getRepairSubCode(data: any) {
    return postApi.post("/code/getRepairSubCode", data);
  },
  setRepairCode(data: any) {
    return postApi.post("/code/setRepairCode", data);
  },
  setRepairSubCode(data: any) {
    return postApi.post("/code/setRepairSubCode", data);
  },
  getStr() {
    return postApi.post("/code/getStr");
  },
  getBrand() {
    return postApi.post("/code/getBrand");
  },
  getItem(data: any) {
    return postApi.post("/code/getItem", data);
  },
  getRepairCodeList(data: any) {
    return postApi.post("/code/getRepairCodeList", data);
  },
  getBadCodeList(data: any) {
    return postApi.post("/code/getBadCodeList", data);
  },
  getJudgCode() {
    return postApi.post("/code/getJudgCode");
  },
};
